import { z } from 'zod'

export const FulfillmentConfig = z.object({
    stock_item_id: z.number(),
    preferred_shipping_provider_id: z.number().nullable(),
    must_ship_separately: z.boolean().nullable().default(false),
})
